import {getClientsAll, getClients} from '../../api/endpoints/clients'

export const state = {
  data: [],
  currentPage: 1,
  rows: 1,
  perPage: 1,
}

export const getters = {
  tableData: s => s.data,
  currentPage: s => s.currentPage,
  rows: s => s.rows,
  perPage: s => s.perPage
}

export const mutations = {
  GET_ROWS(state) {
    getClientsAll().then( res => {
      state.rows = res.data.total
    })
  },
  GET_PER_PAGE(state) {
    getClientsAll().then( res => {
      state.perPage = res.data.per_page
    })
  },
  GET_COUNT(state, id) {
    state.currentPage = id
    getClients(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_DATA(state) {
    getClients(state.currentPage).then( res => {
      state.data = res.data.data
    })
  }
}

export const actions = {
  getRows({commit}) {
    commit('GET_ROWS')
  },
  getPerPage({commit}) {
    commit('GET_PER_PAGE')
  },
  getCount({commit}, params) {
    commit('GET_COUNT', params)
  },
  getData({commit}) {
    commit('GET_DATA')
  }
}